import React, { Component } from 'react';
import { CaseStudies } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * The case studies section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class CaseStudiesView extends Component {

	render () {
		const {
			cases,
			heading,
		} = this.props.content.landingPage.caseStudies;

		return (
			<CaseStudies
				{...{
					cases,
					heading,
				}}
			/>
		);
	}

}

export default withLanguageContext(CaseStudiesView);



// WEBPACK FOOTER //
// ./src/components/views/CaseStudiesView/CaseStudiesView.js